import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { RenderNullableNumberWithSeparators, RenderProgressValue } from "../../../../../../shared/scripts/table-functions";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { SamplesDialog } from "../scripts/samples.dialog";
import { SamplesDatatableEntry } from "./samples-datatable.entities";

export class SamplesDatatableView {
    selectedGrouping: string;

    tableNone: any; tableNoneId: string = "samples-datatable-none";
    tableBySample: any; tableSampleId: string = "samples-datatable-bysamples";
    tableByVisit: any; tableVisitId: string = "samples-datatable-byvisit";
    tableBySite: any; tableSiteId: string = "samples-datatable-bysite";

    // Improve Performance
    currentTableEntriesNon: SamplesDatatableEntry[] = [];
    currentTableEntriesBySample: SamplesDatatableEntry[] = [];
    currentTableEntriesByVisit: SamplesDatatableEntry[] = [];
    currentTableEntriesBySite: SamplesDatatableEntry[] = [];

    constructor() {
        this.selectedGrouping = "none";

        this.tableNone = this.initializeTable(this.tableNoneId, this.tableNoneId + "_wrapper");
        this.tableBySample = this.initializeTable(this.tableSampleId, this.tableSampleId + "_wrapper");
        this.tableByVisit = this.initializeTable(this.tableVisitId, this.tableVisitId + "_wrapper");
        this.tableBySite = this.initializeTable(this.tableSiteId, this.tableSiteId + "_wrapper");

        this.initializeDialog([this.tableNoneId, this.tableSampleId, this.tableVisitId, this.tableSiteId]);
    }

    SetView(newView: string): void {

        //console.log(newView);

        if (!newView.startsWith("samples-datatable")) { return; }

        if (newView.includes("none")) { this.selectedGrouping = "none"; }
        else if (newView.includes("bysamples")) { this.selectedGrouping = "by-samples"; }
        else if (newView.includes("byvisit")) { this.selectedGrouping = "by-visit"; }
        else if (newView.includes("bysite")) { this.selectedGrouping = "by-site"; }

        if (this.selectedGrouping == "none") { SetActiveTab("samples-datatable-tabs", "content-samples-datatable-none"); this.tableNone.columns.adjust(); }
        else if (this.selectedGrouping == "by-samples") { SetActiveTab("samples-datatable-tabs", "content-samples-datatable-bysamples"); this.tableBySample.columns.adjust(); }
        else if (this.selectedGrouping == "by-visit") { SetActiveTab("samples-datatable-tabs", "content-samples-datatable-byvisit"); this.tableByVisit.columns.adjust(); }
        else if (this.selectedGrouping == "by-site") { SetActiveTab("samples-datatable-tabs", "content-samples-datatable-bysite"); this.tableBySite.columns.adjust(); }

        this.UpdateData(this.currentTableEntriesNon, this.currentTableEntriesBySample, this.currentTableEntriesByVisit, this.currentTableEntriesBySite);
    }

    UpdateData(tableEntriesNone: SamplesDatatableEntry[], tableEntriesBySample: SamplesDatatableEntry[], tableEntriesByVisit: SamplesDatatableEntry[], tableEntriesBySite: SamplesDatatableEntry[]): void {
        this.currentTableEntriesNon = tableEntriesNone;
        this.currentTableEntriesBySample = tableEntriesBySample;
        this.currentTableEntriesByVisit = tableEntriesByVisit;
        this.currentTableEntriesBySite = tableEntriesBySite;

        // Only update what is visible
        if ($(`#${this.tableNoneId}`).is(":visible")) {
            this.tableNone.clear();
            this.tableNone.rows.add(this.currentTableEntriesNon).draw();
        }

        if ($(`#${this.tableSampleId}`).is(":visible")) {
            this.tableBySample.clear();
            this.tableBySample.rows.add(this.currentTableEntriesBySample).draw();
        }

        if ($(`#${this.tableVisitId}`).is(":visible")) {
            this.tableByVisit.clear();
            this.tableByVisit.rows.add(this.currentTableEntriesByVisit).draw();
        }

        if ($(`#${this.tableSiteId}`).is(":visible")) {
            this.tableBySite.clear();
            this.tableBySite.rows.add(this.currentTableEntriesBySite).draw();
        }
    }

    private initializeTable(tableId: string, tableWrapperId: string): any {

        let dataTable: any = $('#' + tableId).DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            //pagingType: 'simple',
            //pageLength: 50,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 4
            },
            columns: [
                //{ data: "Study", title: "Platform", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: "Visit", title: "Visit", className: "text-left font-size12 nowrap" },
                { data: "VisitAbb", visible: false },
                { data: "Sample", title: "Biospecimen", className: "text-left font-size12 nowrap" },
                { data: "PotentialSamples", title: "Potential<br>Samples", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "ExpectedSamples", title: "Expected<br>Samples", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "Completed.0", title: "Completed<br>Samples", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "Completed.1", title: "Percent<br>Completed", className: "text-center font-size12 nowrap gray font-underline clickable-completed", render: RenderProgressValue, defaultContent: '' },
                //{ data: "Overdue.0", title: "Overdue<br>Samples", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                //{ data: "Overdue.1", title: "Percent<br>Overdue", className: "text-center font-size12 nowrap gray font-underline clickable-overdue", render: RenderProgressValue, defaultContent: '' },
                { data: "OverdueMissing.0", title: "Overdue/Missing<br>Samples", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "OverdueMissing.1", title: "Percent<br>Overdue/Missing", className: "text-center font-size12 nowrap gray font-underline clickable-overdue-missing", render: RenderProgressValue, defaultContent: '' },
                { data: "NotDone.0", title: "Not Done<br>Samples", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "NotDone.1", title: "Percent<br>Not Done", className: "text-center font-size12 nowrap gray font-underline clickable-notdone", render: RenderProgressValue, defaultContent: '' },
                { data: "DiscPrior.0", title: "Disc. Prior<br>Samples", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "DiscPrior.1", title: "Percent<br>Disc. Prior", className: "text-center font-size12 nowrap gray font-underline clickable-discprior", render: RenderProgressValue, defaultContent: '' },
                { data: "Site", title: "Site Name", className: "text-left font-size10 nowrap", visible: false },
                { data: "NotYetDue", title: "Not Yet Due <br> Samples", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: ''}
            ],
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'Download Table as CSV',
                    charset: 'utf-8',
                    title: "RECOVER-CT Samples Export",
                }
            ],
            createdRow: (row, data: any, index) => {
                //cell formatting on percentages
                if (data.Completed[1] != undefined) { this.setCellPercentValue(row, 'td:eq(6)', this.getCellColorByValue("Completed", data.Completed[1]), data.Completed[0]); }
                //if (data.Overdue[1] != undefined) { this.setCellPercentValue(row, 'td:eq(7)', this.getCellColorByValue("Overdue", data.Overdue[1]), data.Overdue[0]); }
                if (data.OverdueMissing && data.OverdueMissing[1] != undefined) {
                    this.setCellPercentValue(row, 'td:eq(7)', this.getCellColorByValue("OverdueMissing", data.OverdueMissing[1]), data.OverdueMissing[0]);
                }
                if (data.NotDone[1] != undefined) { this.setCellPercentValue(row, 'td:eq(8)', this.getCellColorByValue("NotDone", data.NotDone[1]), data.NotDone[0]); }
                if (data.DiscPrior[1] != undefined) { this.setCellPercentValue(row, 'td:eq(9)', this.getCellColorByValue("DiscPrior", data.DiscPrior[1]), data.DiscPrior[0]); }
            },
            order: [[0, 'asc'], [1, 'asc'], [3, 'asc'], [4, 'asc']],
        });

        dataTable.on('column-visibility.dt', function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        $('[data-toggle="tooltip"]').tooltip()

        return dataTable;
    }
    private getCellColorByValue(dataElement: string, value: number): string {
        if (dataElement == "Completed") {
            if (value >= 0.85) return "#7fb87f";
            else if (value >= 0.65) return "#FCE77D";
            else return "#F07D7D";
        }
        else if (dataElement == "Overdue" || dataElement == "OverdueMissing" || dataElement == "NotDone") {
            if (value < 0.10) return "#7fb87f";
            else if (value <= 0.20) return "#FCE77D";
            else return "#F07D7D";
        }
        else if (dataElement == "DiscPrior") {
            if (value < 0.10) return "#7fb87f";
            else if (value <= 0.20) return "#FCE77D";
            else return "#F07D7D";
        }
    }

    private initializeDialog(tableIds: string[]): void {

        tableIds.forEach((tableId: string) => {
            $('#' + tableId).on('click', 'td.clickable-completed', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                SamplesDialog.ShowDialog(row.CompletedVisits);
            });
            $('#' + tableId).on('click', 'td.clickable-overdue', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                SamplesDialog.ShowDialog(row.OverdueVisits);
            });
            $('#' + tableId).on('click', 'td.clickable-notdone', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                SamplesDialog.ShowDialog(row.NotDoneVisits);
            });
            $('#' + tableId).on('click', 'td.clickable-discprior', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                SamplesDialog.ShowDialog(row.DiscPriorVisits);
            });
            $('#' + tableId).on('click', 'td.clickable-overdue-missing', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                // Combine OverdueVisits and MissingVisits
                SamplesDialog.ShowDialog([...(row.OverdueVisits || []), ...(row.MissingVisits || [])]);
            });
        });
    }
    private setCellPercentValue(row: any, cell: string, color: string, count: number): void {
        $(cell, row).css('background-color', color);
        $(cell, row).attr('title', 'n = ' + count);
        $(cell, row).attr('data-toggle', 'tooltip');
        $(cell, row).attr('data-placement', 'top');
    }
    exportTable(): void {

        let tableId: string = undefined;
        if (this.selectedGrouping == "none") { tableId = this.tableNoneId; }
        else if (this.selectedGrouping == "by-samples") { tableId = this.tableSampleId; }
        else if (this.selectedGrouping == "by-visit") { tableId = this.tableVisitId; }
        else if (this.selectedGrouping == "by-site") { tableId = this.tableSiteId; }
        if (tableId != undefined) {
            // let table = $("#" + tableId).DataTable();
            let table = $("#" + this.tableNoneId).DataTable();
            (<any>table).button(0).trigger();
        }
    }

    private setCountFoundLabel(tableId: string, count: number): void {

        switch (count) {
            case 0: $('#' + tableId + '-found-count').text("No Records Found"); break;
            case 1: $('#' + tableId + '-found-count').text("1 Record Found"); break;
            default: $('#' + tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Records Found");
        }
    }

    private refresh(): void {
        //this.dataTable.columns.adjust();
        //this.tableColumnController.refresh();
    }

    private clearSearchBar(): void {
        //this.dataTable.search('').draw();
    }
}